import React from 'react'

const Button = (props) => {
  const styles = {
    backgroundColor: props.isActive ? "#80B461" : "#A4A4A4"
  }
  return (
    <button style={styles} className="ingredient_button" onClick={props.activateIngredient}>
      {props.item.type}
    </button>
  )
}

export default Button